/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CandidateOffersIdApplyQuestions
 */
export interface CandidateOffersIdApplyQuestions {
    /**
     * 
     * @type {number}
     * @memberof CandidateOffersIdApplyQuestions
     */
    id?: number;
    /**
     * Para las respuestas closed
     * @type {number}
     * @memberof CandidateOffersIdApplyQuestions
     */
    answerId?: number;
    /**
     * Para las respuestas open
     * @type {string}
     * @memberof CandidateOffersIdApplyQuestions
     */
    answerText?: string;
}

export function CandidateOffersIdApplyQuestionsFromJSON(json: any): CandidateOffersIdApplyQuestions {
    return CandidateOffersIdApplyQuestionsFromJSONTyped(json, false);
}

export function CandidateOffersIdApplyQuestionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateOffersIdApplyQuestions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'answerId': !exists(json, 'answer_id') ? undefined : json['answer_id'],
        'answerText': !exists(json, 'answer_text') ? undefined : json['answer_text'],
    };
}

export function CandidateOffersIdApplyQuestionsToJSON(value?: CandidateOffersIdApplyQuestions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'answer_id': value.answerId,
        'answer_text': value.answerText,
    };
}


